(() => {
  const modal = document.getElementById('twt-quiz-popup');
  if (!modal || window.Shopify?.designMode) return;

  const seenKey = 'twt-quiz-popup-seen-v1';
  const subscribedKey = 'twt-newsletter-subscribed-v1';
  const sessionKey = 'twt-quiz-popup-session-v1';
  const lifetime = 365 * 24 * 60 * 60 * 1000;
  let timer;
  let stopped = false;
  let storageAvailable = true;

  const read = (key) => {
    try {
      return localStorage.getItem(key);
    } catch {
      storageAvailable = false;
      return null;
    }
  };
  const recent = (key) => {
    const timestamp = Number(read(key));
    return timestamp > 0 && Date.now() - timestamp < lifetime;
  };
  const write = (key) => {
    try {
      localStorage.setItem(key, String(Date.now()));
    } catch {
      storageAvailable = false;
    }
  };
  const stop = () => {
    stopped = true;
    clearTimeout(timer);
    try {
      sessionStorage.setItem(sessionKey, '1');
    } catch {}
  };
  const markSubscribed = () => {
    write(subscribedKey);
    stop();
  };

  document.addEventListener('twt:quiz-subscribed', (event) => {
    if (event.detail?.quiz_subscribe_ok === true) markSubscribed();
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form instanceof HTMLFormElement &&
        form.querySelector('input[name="form_type"][value="customer"]') &&
        form.checkValidity()) stop();
  });

  if (modal.dataset.customerKnown === 'true') {
    write(seenKey);
    stop();
    return;
  }
  if (new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
    markSubscribed();
    return;
  }
  try {
    if (JSON.parse(read('twt-quiz-state-v2') || 'null')?.answers?.email) {
      write(seenKey);
      stop();
    }
  } catch {}

  const blocked = () => {
    if (stopped || recent(seenKey) || recent(subscribedKey) || !storageAvailable) return true;
    try {
      return sessionStorage.getItem(sessionKey) === '1';
    } catch {
      return true;
    }
  };
  const rememberShown = () => {
    write(seenKey);
    stop();
  };

  new MutationObserver(() => {
    if (modal.hasAttribute('open')) rememberShown();
  }).observe(modal, { attributes: true, attributeFilter: ['open'] });

  document.addEventListener('click', (event) => {
    if (event.target.closest?.('twt-quiz, modal-opener[data-modal="#twt-quiz-popup"]')) stop();
  }, { capture: true });
  window.addEventListener('storage', (event) => {
    if (event.key === seenKey || event.key === subscribedKey) stop();
  });
  window.addEventListener('pagehide', () => clearTimeout(timer));

  const schedule = () => {
    clearTimeout(timer);
    if (modal.dataset.autoOpen !== 'true' || document.visibilityState !== 'visible' || blocked()) return;
    timer = setTimeout(() => {
      if (document.visibilityState !== 'visible' || blocked() || typeof modal.show !== 'function') return;
      const otherDialog = [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')]
        .some((dialog) => !modal.contains(dialog) && dialog.getClientRects().length > 0 &&
          getComputedStyle(dialog).visibility !== 'hidden');
      const busy = document.body.classList.contains('overflow-hidden') || otherDialog ||
        document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
      if (busy) {
        stop();
        return;
      }
      write(seenKey);
      if (!storageAvailable) return;
      modal.show(document.activeElement);
      rememberShown();
    }, 3000);
  };
  document.addEventListener('visibilitychange', schedule);
  schedule();
})();
